<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-6 text-left">
          <h4>Select EM document</h4>
        </div>
        <div class="col-6 text-right pr-1">
          <appModalEMDocumentNew></appModalEMDocumentNew>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row justify-content-left selectableCard">
        <div
          class="col-sm-3 mt-3"
          v-for="(item, index) in getEMDocumentPaginateData.data"
          :key="item.id"
        >
          <div
            class="card text-center"
            @click="fnSelectDocument(item.id)"
            :class="{ active: docId == item.id }"
          >
            <div class="card-body" :class="{ active: docId == item.id }">
              <object
                :data="item.url"
                type="application/pdf"
                width="300"
                height="200"
              ></object>

              <h4 class="card-text fw-500">
                <a :href="item.url" target="_blank">{{ item.title }}</a>
              </h4>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <pagination
            :limit="5"
            :data="getEMDocumentPaginateData"
            @pagination-change-page="fnGetEMDocumentPaginate"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import pagination from 'laravel-vue-pagination'
import appModalEMDocumentNew from '../../components/emailMarketing/ModalEMDocumentNew.vue'
export default {
  name: 'EMStep2',
  components: {
    pagination,
    appModalEMDocumentNew
  },
  data() {
    return {
      errors: {},
      docId: '',
      loading: false,

      selected: [],
      quoteList: {},
      recordsPerPage: 8,
      page: 1,
      q: '',
      selectedStatus: 1,
      sort_direction: 'asc',
      sort_field: 'id',
      paginate: {
        dealerUserId: '',
        page: 1,
        recordsPerPage: 8,
        q: '',
        selectedStatus: 1,
        sort_direction: 'asc',
        sort_field: 'id'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getEMDocumentPaginateData',
      'getEMDocumentPaginate',
      'getEMWizardData'
    ])
  },
  methods: {
    ...mapActions(['fetchEMDocumentPaginate', 'fetchEMWizardData']),
    fnSelectDocument(docId) {
      this.docId = docId
    },
    fnGetEMDocumentPaginate: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchEMDocumentPaginate(objNew)
    }
  },
  mounted() {
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 8,
      q: '',
      selectedStatus: 1,
      sort_direction: 'asc',
      sort_field: 'id'
    }
    let objNew = { ...obj1, ...obj2 }
    this.fetchEMDocumentPaginate(objNew)
  },
  watch: {
    docId(newValue) {
      let obj = { docId: newValue }
      this.fetchEMWizardData({ ...this.getEMWizardData, ...obj })
    }
  }
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
</style>
